<template>
  <div ref="nav" class="nav">
    <MenuList v-if="menu" :responsive="responsive" :lang="lang" :list="menu.list" />
    <!-- <a href="#" class="btn btnFull">셀프 체크아웃</a> -->
    <Sns :list="sns" />
    <div v-if="viewMore || goTop" class="naviBox">
      <button v-if="viewMore" type="button" class="btnNavi viewMore" @click.stop="setMenuScroll('bottom')"></button>
      <button v-if="goTop" type="button" class="btnNavi goTop" @click.stop="setMenuScroll('top')"></button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MenuList from '@/components/Nav/MenuList.vue'
import Sns from '@/components/Nav/Sns.vue'

export default {
  name: 'Nav',
  props: [
    'lang',
    'responsive'
  ],
  components: {
    MenuList,
    Sns
  },
  computed: {
    ...mapGetters({
      menu: 'common/getMenu'
    }),
    sns () {
      return this.menu && this.menu.sns && this.menu.sns.filter(x => x.active)
    }
  },
  watch: {
    '$route' (to, from, next) {
      if (to.name === 'main') {
        const nav = this.$refs.nav
        if (nav) {
          nav.scrollTo(0, 0)
        }
      }
    },
  },
  created () {
    // const hasMenu = this.$store.getters['common/getMenu']
    // if (!hasMenu) {
    //   this.$store.dispatch('setting/loadSetting')
    // }
  },
  mounted () {
    this.$nextTick(() => {
      const nav = this.$refs.nav
      if (nav && nav.offsetHeight < nav.scrollHeight) {
        const scrollRange = nav.scrollHeight - nav.clientHeight
        if (scrollRange > 100) {
          nav.addEventListener('scroll', this.setScrollbarPosition)
          this.setScrollbarPosition()
        }
      }
    })
  },
  data () {
    return {
      scrollbarPosition: null,
      viewMore: false,
      navPositionTop: 0,
      navPositionBottom: 0,
      goTop: false
    }
  },
  methods: {
    setScrollbarPosition (e) {
      const nav = this.$refs.nav
      const scrollTop = nav.scrollTop
      const scrollRange = parseInt((nav.scrollHeight - nav.clientHeight) / 2)
      this.navPositionTop = nav.offsetTop
      this.viewMore = scrollTop <= scrollRange
      this.goTop = scrollTop > scrollRange
    },
    setMenuScroll (position) {
      const nav = this.$refs.nav
      const scrollTop = position === 'top' ? 0 : nav.scrollHeight
      nav.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.naviBox {
  position: absolute;
  bottom: 8px;
  left: 0;
  width: 100%;
  text-align: center;
}
.btnNavi {
  width: 64px;
  height: 32px;
  margin: 0 8px;
  padding: 8px 12px;
  white-space: nowrap;
  color: $color-white;
  border-radius: 8px;
  border: 1px solid rgba(255,255,255,0.1);
  background-color: rgba(0,0,0,0.3);
  &:before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background: url('~@/assets/img/ico_arr_down_wh.png') 50% 50% / 18px no-repeat;
    opacity: 0.7;
  }
  &.goTop:before {
    transform: rotate(180deg);
  }
}
</style>
